<template>
  <dialogBar @on-close="close" v-if="config.show" :dialog-width="config.width">
    <div slot="header">{{config.title}}</div>
    <div class="dialog_publish_main" slot="main">
      <el-form ref="form" :model="config.data" :rules="rules" label-width="80px">
        <el-form-item v-if="config.type==0" label="账号" prop="userName">
          <el-input size="mini" v-model="config.data.userName"></el-input>
        </el-form-item>
        <el-form-item v-if="config.type!=2" label="手机号" prop="phoneNumber">
          <el-input size="mini" v-model="config.data.phoneNumber"></el-input>
        </el-form-item>
        <el-form-item v-if="config.type!=2" label="邮箱" prop="email">
          <el-input size="mini" v-model="config.data.email"></el-input>
        </el-form-item>
        <el-form-item v-if="config.type!=1" label="密码" prop="pwd">
          <el-input type="password" size="mini" v-model="config.data.pwd"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="info" size="mini" @click="close(false)">取消</el-button>
      <el-button type="primary" size="mini" @click="onSubmit()">确认</el-button>
    </div>
  </dialogBar>
</template>
<script>
import dialogBar from "./comment/dialogBar";
import { promised } from "q";

export default {
  components: {
    dialogBar: dialogBar
  },
  props: {
    config: {
      type: Object,
      default: {
        show: false,
        width: 800,
        title: "",
        type: 0, //0 创建，1 修改名称，2 重置密码
        data: {}
      }
    }
  },
  data() {
    var validateName = (rule, value, callback) => {
          if (value.length>20) {
            callback(new Error('账号最多20个字'));
          } 
          callback();
        };
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    var checkPwd = (rule, value, callback) => {
      const reg =   /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>,.\/]).{6,18}/;
      if (reg.test(value)) {
        callback();
      } else {
        return callback(
          new Error("密码至少6位，且存在大写字母、小写字母、数字、特殊字符")
        );
      }
    };
    return {
      ruleForm: {
        userName: ''
            },
      rules: {
        userName: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { validator: validateName, trigger: 'blur' }
        ],
        phoneNumber: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" }
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" }
        ],
        pwd: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          { validator: checkPwd, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    close(result) {
      this.config.show = false;
      if (result) this.$emit("close");
    },
    onSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          switch (this.config.type) {
            case 0:
              await this.$promission.post("/api/Users", this.config.data);
              this.$message({
                showClose: true,
                type: "success",
                message: "创建成功!"
              });
              break;
            case 1:
              await this.$promission.post(
                "/api/Users/Update",
                this.config.data
              );
              this.$message({
                showClose: true,
                type: "success",
                message: "修改成功!"
              });
              break;
            case 2:
              await this.$promission.post(
                "/api/Users/ResetPwd",
                this.config.data
              );
              this.$message({
                showClose: true,
                type: "success",
                message: "密码重置成功!"
              });
              break;
          }
          this.close(true);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog_publish_main {
  padding-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/PeopleEduit.vue